import { makeAutoObservable } from "mobx";
import { RootStore } from "./RootStore";
import { UserType } from "../components/main/body/screens/IAM/Users/types/UserType";

interface Activity {
    id: number;
    medicalEmergencyId: number;
    passengerName: string;
    actionTaken: string;
    actionBy: string;
    assignedEms: string;
    timestamp: string;
}

export class AdminHomeStore {
    activityList = [];
    activeUserEvent = [];
    activityFilterDropdown: boolean = false;
    activeIncidentList = [];
    filterMedical = [];
    user: UserType[] = [];
    activeButton: string = "active";
    vGraphActiveBtn: number = 0;
    dGraphActiveBtn: number = 0;
    listedIncidentIds: number[] = [];
    filterAllMedicalIncidentState: string = "new";
    activityHeight: number = 0;
    
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    setActivity = (activities: []) => {
        this.activityList = activities;
    }
    get getActivityList() {
        return this.activityList;
    }

    setActiveUser = (activeUserEvent: []) => {
        this.activeUserEvent = activeUserEvent;
    }
    get getActiveUser() {
        return this.activeUserEvent;
    }
    
    setActivityFilter = () => {
        this.activityFilterDropdown = !this.activityFilterDropdown;
    }
    get getActivityFilter() {
        return this.activityFilterDropdown;
    }

    setActiveIncident = (activeIncidents: []) => {
        this.activeIncidentList = activeIncidents;
    }
    get getActiveIncidentList() {
        return this.activeIncidentList;
    }

    setFilterMedical = (activeIncidents: []) => {
        this.activeIncidentList = activeIncidents;
    }
    get getFilterMedical() {
        return this.activeIncidentList;
    }

    handleActiveButton = (btnTitle: string) => {
        this.activeButton = btnTitle;
    }
    get getActiveButton() {
        return this.activeButton;
    }
    resetActiveButton = () => {
        this.activeButton = "active";
    }

    handleVGraphActiveButton = (btnTitle: number) => {
        this.vGraphActiveBtn = btnTitle;
    }
    get getVGraphActiveButton() {
        return this.vGraphActiveBtn;
    }

    handleDGraphActiveButton = (btnTitle: number) => {
        this.dGraphActiveBtn = btnTitle;
    }
    get getDGraphActiveButton() {
        return this.dGraphActiveBtn;
    }

    handleUsers = (users:   UserType[]) => {
        this.user = users;
    }
    get getUsers() {
        return this.user;
    }

    setIncidentId = (id: number) => {
        if (!this.listedIncidentIds.includes(id)) {
            this.listedIncidentIds.push(id);
        }
    }
    get getIncidentList() {
        return this.listedIncidentIds.join(",");
    }
    resetIncidentList = () => {
        this.listedIncidentIds = [];
    }

    setFilterAllMedicalIncidentState = (filterType: string) => {
        this.filterAllMedicalIncidentState = filterType;
    }
    get getFilterAllMedicalIncidentState() {
         return this.filterAllMedicalIncidentState;
    }
    resetFilterAllMedicalIncidentState = () => {
        this.filterAllMedicalIncidentState = "new";
    }

    setActivityHeight = (height: number) => {
        this.activityHeight = height;
    }
    get getActivityHeight() {
        return this.activityHeight;
    }
}